import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import { Text } from '@chakra-ui/react'

import { ButtonClean, ButtonPrimary } from 'front-end/src/components'
import { Modal } from '../../../components/common/modal/Modal'
import IconLock from '../../../components/common/icon/IconLock'
import { usePatchCertificationMutation } from '../manage/CertificationsDrawer.codegen'
import { brandColors } from 'shared/basicPalette'

export const LockingModal: FC<{
  show: boolean
  onCancel: () => void
  onConfirm: () => void
  certificationId: number
}> = ({ show, certificationId, onCancel, onConfirm }) => {
  const [patchFn] = usePatchCertificationMutation()

  return (
    <Modal
      header={
        <>
          <div className="SurveySendPublishModal__icon">
            <i className="icon-lock" />
          </div>
          <h3>
            <Trans>Lock this certification?</Trans>
          </h3>
        </>
      }
      size="MEDIUM"
      show={show}
      controls={
        <>
          <ButtonClean onClick={onCancel}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonPrimary
            onClick={async () => {
              await patchFn({
                variables: {
                  id: certificationId,
                  data: {
                    locked_at: new Date()
                  }
                }
              })
              onConfirm()
            }}
            leftIcon={<IconLock />}
          >
            <Trans>Lock certification</Trans>
          </ButtonPrimary>
        </>
      }
    >
      <Text color={brandColors.grey.mid}>
        <Trans>
          To share this certification we need to <b>lock adding and deleting</b>{' '}
          the content of this certification first.
        </Trans>
      </Text>
    </Modal>
  )
}
